<div class="kpi-card">
  <header class="kpi-card__header">
    <h3 class="kpi-card__title">{{ category }}</h3>
  </header>
  <section
    class="kpi-card__body"
    [style.--kpi-width.px]="kpiWidth"
    kpiCardWrapDirective
    [kpiCount]="kpiCount"
    [kpiWidth]="kpiWidth"
    x
  >
    <ng-container *ngFor="let kpi of kpis | keyvalue: sortKpisByName; let i = index">
      <kpi
        *ngIf="kpi.value"
        [kpi]="kpi.value"
        [kpiKey]="getKpiKey(kpi.key)"
        [keyMilestones]="keyMilestones"
        [width]="kpiWidth"
      ></kpi>
    </ng-container>
  </section>
</div>
